import { render, staticRenderFns } from "./_base-google-autocomplete.vue?vue&type=template&id=03546a24"
import script from "./_base-google-autocomplete.vue?vue&type=script&lang=js"
export * from "./_base-google-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./_base-google-autocomplete.vue?vue&type=style&index=0&id=03546a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports